import type { HTMLAttributes, ReactNode } from 'react';
import { useDragScroll } from '@/shared/lib/useDragScroll';

interface DragScrollProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/**
 * 가로 스크롤 행 래퍼 — 마우스/펜 드래그로 넘길 수 있고, 드래그 끝의 클릭은 무시한다.
 * 기존 overflow-x-auto div를 그대로 대체한다(className·role·aria 등 전달).
 */
export function DragScroll({ children, style, ...rest }: DragScrollProps) {
  const ref = useDragScroll<HTMLDivElement>();
  return (
    <div ref={ref} style={{ touchAction: 'pan-x', ...style }} {...rest}>
      {children}
    </div>
  );
}
